import React, {Component} from "react";
import { isSimilarObject } from '../../../helper';

export default class CostPane extends Component {

    // shouldComponentUpdate(nextProps) {
    //     if(isSimilarObject(this.props, nextProps)) {
    //         return false;
    //     }
    //     return true;
    // }

    render() {
        const { handlePrice, handleSubmitType, errorMessages, inputProps } = this.props;
        let { price, commission, tax_duplicate, isFetching, publish, averagePrice, totalPrice, contractor_count } = inputProps;
    
        return (
            <div className="cost general-settings-new-style">
                <div style={{display:'flex',alignItems:'center', marginBottom: '25px'}}>
                    <h3 style={{margin:0}}>Ваш проект</h3>
                    <div className="create-order__executor-count">x{contractor_count}</div>
                </div>
                
                <div className="cost-report" style={{flexDirection:'column'}}>
    
                    <div className="to-pay" style={{flexDirection:'row', width:'100%', justifyContent: 'space-between', alignItems: 'center'}}>
                        <div style={{width: '100%'}}>
                            <div style={{marginBottom: '25px', width: '40%'}}>
                                <div style={{display:'flex',alignItems:'center'}}>
                                    <input
                                        // required={publish ? true : false}
                                    //   pattern="^[1-9]+[0-9]*$"
                                        onChange={(e) => handlePrice(e.target.value)}
                                        value={price}
                                        type="text"
                                        className="width100"
                                        placeholder="Ваша цена"
                                    />
                                    <div className="create-order__price-executor-count">x{contractor_count}</div>
                                </div>
    
                                {
                                    errorMessages.price ?
                                    <div className="input-error-text etmt10">{errorMessages.price}</div>
                                    : null
                                }
                            </div>
                        </div>
    
                        <div className="form__label">
                            <span className="label create-order__commission-label">Средняя стоимость проекта на сервисе: </span>
                            <span className="comission-value create-order__commission-value">{averagePrice} р.</span>
                            {/* {`Средняя стоимость проекта на сервисе ${averagePrice} р.`} */}
                        </div>
    
                        <div className="commission" style={{width: '100%'}}>
                            <span className="label create-order__commission-label">Комиссия сервиса: </span>
                            <span className="comission-value create-order__commission-value">{commission} р.</span>
                        {tax_duplicate > 0 ?
                            <span>
                                <br />
                                <span className="label create-order__commission-label">Комиссия автору копируемого заказа: </span>
                                <span className="comission-value create-order__commission-value">{tax_duplicate} р.</span>
                            </span>
                         : ''}
                        </div>
                    </div>
    
                    <div className="to-pay-caption create-order__total-price">
                        <span>Сумма к оплате:</span>
                        <span>{totalPrice > 0 ? parseFloat(totalPrice) : 0} p.</span>
                        
                        {/* <div className="to-pay-value">{totalPrice > 0 ? parseFloat(totalPrice) : 0} p.</div> */}
                    </div>
                </div>
    
                <div className="actions">
                    <div className="big-button empty-button">{/*isFetching && !publish*/}
                        <button
                            onClick={() => handleSubmitType(false)}
                            id="chernovik">Сохранить черновик</button>
                    </div>
                    <div className="big-button button-action">{/*isFetching && publish*/}
                        <button
                            onClick={() => handleSubmitType(true)}
                            id="oplatit"
                            className={isFetching ? 'disabled' : ''}>Разместить заказ</button>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/MakeOrder/NewAndEdit/CostPane.js